export default __webpack_public_path__ + "static/media/franswillame-silva.dde14188.webp";